import { createContext, type ReactNode, useContext } from "react";
import { AU_CONFIG, REGION_CONFIGS, type RegionCode, type RegionConfig } from "./region";

const RegionContext = createContext<RegionConfig | null>(null);

export const useRegion = (): RegionConfig => {
    const ctx = useContext(RegionContext);
    if (!ctx) return AU_CONFIG;
    return ctx;
};

export const useRegionSafe = (): RegionConfig | null => {
    return useContext(RegionContext);
};

interface RegionProviderProps {
    region?: RegionCode;
    children: ReactNode;
}

export const RegionProvider: React.FC<RegionProviderProps> = ({ region = "AU", children }) => {
    const config = REGION_CONFIGS[region] ?? AU_CONFIG;
    return <RegionContext.Provider value={config}>{children}</RegionContext.Provider>;
};
